<template>
	<div :class="containerClass">
		<div v-if="title" class="mb-6 mt-2 border-b border-dark dark:border-light">
			<h3 class="mb-2">{{ title }}</h3>
		</div>
		<div class="mx-auto mb-2 flex w-full flex-row flex-wrap gap-2 md:mb-5">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		containerClass: String
	}
}
</script>
